module.exports = __webpack_public_path__ + "img/image 07.b8024204.png";